export const getPriceColor = (shouldBidAmountBeGreen) => {
  if (!shouldBidAmountBeGreen) return null;
  return {
    color: '#1AB394',
    fontWeight: 600,
  };
};
